import React, { useState, useEffect } from "react";
import { compressImageFile } from "../../helpers/imageCompress";
import useDateRangeHandler from "./useDateRangeHandler";
import { Pagination, PaginationItem, PaginationLink } from "reactstrap";
// import SimpleRoomDropdown from './RoomSelection';
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Table,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  FormGroup,
  Label,
  Input,
  Badge,
} from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import ReservationStatusBadge from "../../customcomponents/ReservationStatusBadge";
import {
  addReservationAPI,
  getHotelReservations,
  getReservationById,
  updateReservation,
  getByMobileNumber,
  GetAllRooms,
  checkoutReservation,
  checkinReservation,
  fetchReservationDetails,
  updatecheckintimeAPI,
  updatecheckouttimeAPI,
} from "../../helpers/api.ts";
import RoomDropdown from "./RoomSelection";
import Swal from "sweetalert2";
import useReservationForm from "./useReservationForm";
import { useNavigate } from "react-router-dom";
import CheckoutModal from "../Reservations/CheckOutmodal.js";
import GuestPartnerForm from "./GuestPartnerForm";
import AmountStatusFilter from "./AmountStatusFilter";
import ReservationExcelExport from "../../customcomponents/ReservationExcelExport";
import moment from "moment";

const Reservations = () => {

  const rd = (r) => r?.reservation_details || r?.reservationDetails || r?.reservation || r || {};
const gd = (r) => r?.guest_details || r?.guestDetails || r?.guest || {};
const roomd = (r) => r?.room_details || r?.roomDetails || r?.room || {};



  // Helper functions for time conversion
  const convertTo12Hour = (time24) => {
    if (!time24) return "";
    const [hours, minutes] = time24.split(":");
    const hour = parseInt(hours);
    const ampm = hour >= 12 ? "PM" : "AM";
    const hour12 = hour === 0 ? 12 : hour > 12 ? hour - 12 : hour;
    return `${hour12.toString().padStart(2, "0")}:${minutes} ${ampm}`;
  };

  const convertTo24Hour = (time12) => {
    if (!time12) return "";
    const [time, ampm] = time12.split(" ");
    const [hours, minutes] = time.split(":");
    let hour = parseInt(hours);

    if (ampm === "PM" && hour !== 12) {
      hour += 12;
    } else if (ampm === "AM" && hour === 12) {
      hour = 0;
    }

    return `${hour.toString().padStart(2, "0")}:${minutes}`;
  };

  const getCurrentTime12Hour = () => {
    const now = new Date();
    const hours = now.getHours();
    const minutes = now.getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";
    const hour12 = hours === 0 ? 12 : hours > 12 ? hours - 12 : hours;
    return `${hour12.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")} ${ampm}`;
  };

  const [reservations, setReservations] = useState([]);
  const [filteredReservations, setFilteredReservations] = useState([]);
  const [rooms, setRooms] = useState([]);
  const [filteredRooms, setFilteredRooms] = useState([]);
  const [roomSearchQuery, setRoomSearchQuery] = useState("");
  const [amountStatusFilter, setAmountStatusFilter] = useState("");
  const [modal, setModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [currentReservationId, setCurrentReservationId] = useState(null);
  const {
    formData,
    dateError,
    partnerFileSizeErrors,
    handleDateChange,
    handleInputChange,
    resetForm,
    setFormData,
    addGuestPartner,
    removeGuestPartner,
    handlePartnerInputChange,
    handlePartnerFileChange,
    clearPartnerFileSizeErrors,
  } = useReservationForm();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const navigate = useNavigate();
  const [fileInputs, setFileInputs] = useState({
    id_proof_front: null,
    id_proof_back: null,
    guest_photo: null,
  });
  const [fileSizeErrors, setFileSizeErrors] = useState({
    id_proof_front: null,
    id_proof_back: null,
    guest_photo: null,
  });
  const [checkoutModal, setCheckoutModal] = useState(false);
  const [checkinModal, setCheckinModal] = useState(false);
  const [checkinDetails, setCheckinDetails] = useState({
    reservation_id: null,
    guest_name: "",
    room_number: "",
    check_in_date: "",
    check_in_time: "",
  });
  const [checkoutDetails, setCheckoutDetails] = useState({
  room_number: "",
  guest_name: "",
  check_in_date: "",
  check_out_date: "",
  room_details: {},

  food_charges: 0,
  spa_appointments: [],
  spa_billing_details: [],

  discount: 0,
  room_charges: 0,
  spa_charges: 0,
  total_spa_charges: 0,
  extra_bed_charges: 0,

  total_amount: 0,
  final_amount: 0,
  payment_mode: "",
  payment_status: "PENDING",
  notes: "",
  pending_amount: 0,

  // ✅ Restaurant display-only payment metadata
  food_payment_status: "UNPAID",
  food_payment_source: "NONE",
  food_direct_invoice_numbers: [],
  direct_food_invoice_numbers: [],

  // ✅ SPA display-only payment metadata
  spa_payment_status: "UNPAID",
  spa_payment_source: "NONE",
  spa_direct_invoice_numbers: [],
});
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    fetchReservations();
    fetchRooms();
  }, []);

  useEffect(() => {
    if (roomSearchQuery) {
      const filtered = rooms.filter(
        (room) =>
          room.room_number
            .toLowerCase()
            .includes(roomSearchQuery.toLowerCase()) ||
          room.room_type.toLowerCase().includes(roomSearchQuery.toLowerCase())
      );
      setFilteredRooms(filtered);
    } else {
      setFilteredRooms(rooms);
    }
  }, [roomSearchQuery, rooms]);

  // Filter reservations based on amount status
  useEffect(() => {
    if (amountStatusFilter) {
      const filtered = reservations.filter(
        (reservation) =>
        (rd(reservation)?.Amount_Status ?? "") === amountStatusFilter

      );
      setFilteredReservations(filtered);
    } else {
      setFilteredReservations(reservations);
    }
  }, [amountStatusFilter, reservations]);

  const fetchRooms = async () => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      let hotel_id1;
      if (user?.role === "RECEPTIONIST") {
        hotel_id1 = user?.hotel?.hotel_id;
      } else {
        hotel_id1 = user?.hotel_id;
      }
      const userData = {
        hotel_id: hotel_id1,
      };
      const response = await GetAllRooms(userData);
      if (response.success) {
        setRooms(response.data);
        setFilteredRooms(response.data);
      }
    } catch (error) {
      console.error("Error fetching rooms:", error);
    }
  };

  const searchGuestByMobile = async (mobileNumber) => {
    try {
      const formDataToSend = {};
      const response = await getByMobileNumber(mobileNumber, formDataToSend);
      if (response.success) {
        setFormData((prev) => ({
          ...prev,
          guest_id: response.data.guest_id,
          guest_name: response.data.first_name + " " + response.data.last_name,
          mobile_number: mobileNumber,
        }));
      }
    } catch (error) {
      console.log("Guest not found");
    }
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    fetchReservations(pageNumber);
  };

  const handleAmountStatusChange = (status) => {
    setAmountStatusFilter(status);
  };

  // const fetchReservations = async () => {
  //   try {
  //     // const user = JSON.parse(localStorage.getItem("user") || "{}");
  //     // const hotel_id =
  //     //   user?.role === "HOTEL_ADMIN" ? user?.hotel_id : user?.hotel?.hotel_id;

  //     // if (!hotel_id) {
  //     //   console.error("Hotel ID not found");
  //     //   return;
  //     // }

  //     const response = await getHotelReservations();

  //     if (response.success) {
  //       setReservations(response.data.reservations);
  //       setFilteredReservations(response.data.reservations);
  //       setTotalPages(response.data.pagination.totalPages);
  //       setTotalItems(response.data.pagination.total);
  //       setCurrentPage(response.data.pagination.currentPage);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching reservations:", error);
  //   }
  // };
  const fetchReservations = async (pageNumber = 1) => {
  try {
    const user = JSON.parse(localStorage.getItem("user") || "{}");
    
    // ✅ CRITICAL: Determine hotel_id based on role
    let hotel_id;
    if (user?.role === "HOTEL_ADMIN") {
      hotel_id = user?.hotel_id;
    } else if (["RECEPTIONIST", "SPA", "FOOD AND BEVERAGE", "MANAGER"].includes(user?.role)) {
      hotel_id = user?.hotel?.hotel_id;
    }

    // Pass hotel_id in the API call
    const response = await getHotelReservations({ 
      hotel_id, // ✅ Pass this explicitly
      page: pageNumber 
    });

    if (response.success) {
      setReservations(response.data.reservations);
      setFilteredReservations(response.data.reservations);
      setTotalPages(response.data.pagination.totalPages);
      setTotalItems(response.data.pagination.total);
      setCurrentPage(response.data.pagination.currentPage);
    }
  } catch (error) {
    console.error("Error fetching reservations:", error);
  }
};

  const originalResetForm = resetForm;
  const resetFormWithFiles = () => {
    originalResetForm();
    setFileInputs({
      id_proof_front: null,
      id_proof_back: null,
      guest_photo: null,
    });
    setFileSizeErrors({
      id_proof_front: null,
      id_proof_back: null,
      guest_photo: null,
    });
    clearPartnerFileSizeErrors();
  };

  const handleFileChange = async (e) => {
    const { name, files } = e.target;
    const file = await compressImageFile(files[0]);

    // Validate file size (5MB = 5 * 1024 * 1024 bytes)
    const maxSize = 2 * 1024 * 1024;
    let error = null;

    if (file && file.size > maxSize) {
      error = `File size must be less than 5MB. Current size: ${(
        file.size /
        (1024 * 1024)
      ).toFixed(2)}MB`;
    }

    // Update file size errors
    setFileSizeErrors((prev) => ({
      ...prev,
      [name]: error,
    }));

    setFileInputs((prev) => ({
      ...prev,
      [name]: file || null,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const user = JSON.parse(localStorage.getItem("user"));
      const hotel_id =
        user?.role === "HOTEL_ADMIN" ? user?.hotel_id : user?.hotel?.hotel_id;
      

      // if (!hotel_id) {
      //   console.error("Hotel ID not found");
      //   return;
      // }

      // Validate required fields
      if (!formData.room_id || !formData.guest_id) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Please select a room and guest before proceeding",
        });
        setIsSubmitting(false);
        return;
      }

      const advanceAmt = Number(formData.Amount_Advance) || 0;
const tariffAmt = Number(formData.tariff_charges) || 0;

if (tariffAmt > 0 && advanceAmt > tariffAmt) {
  Swal.fire({
    icon: "error",
    title: "Invalid Advance Amount",
    text: `Advance amount (₹${advanceAmt}) cannot be greater than room tariff charges (₹${tariffAmt}). Please correct it before submitting.`,
  });
  setIsSubmitting(false);
  return;
}

      // Check for file size errors
      const hasFileSizeErrors =
        Object.values(fileSizeErrors).some((error) => error !== null) ||
        Object.values(partnerFileSizeErrors).some((error) => error !== null);

      if (hasFileSizeErrors) {
        Swal.fire({
          icon: "error",
          title: "File Size Error",
          text: "Please fix file size errors before submitting the form",
        });
        setIsSubmitting(false);
        return;
      }

      const formDataToSend = new FormData();

      // Ensure numeric fields are sent as numbers
      const numericFields = [
        "room_id",
        "guest_id",
        "hotel_id",
        "number_of_nights",
        "tariff_charges",
        "food_charges",
        "no_of_beds",
        "discount",
        "extrabedcharges",
        "Amount_Advance",
      ];

      // Append all regular form fields except files and guest partners
      Object.keys(formData).forEach((key) => {
        if (
          ![
            "id_proof_front",
            "id_proof_back",
            "guest_photo",
            "guest_partners",
          ].includes(key)
        ) {
          if (numericFields.includes(key)) {
            // Convert to number and validate
            const value = parseInt(formData[key]);
            formDataToSend.append(key, isNaN(value) ? 0 : value);
          } else {
            formDataToSend.append(key, formData[key] || "");
          }
        }
      });

      // Append main guest files
      Object.entries(fileInputs).forEach(([key, file]) => {
        if (file) {
          formDataToSend.append(key, file);
        }
      });

      formDataToSend.append("hotel_id", hotel_id);

      // Log guest partners data before processing
      console.log("Processing guest partners:", formData.guest_partners);

      // Validate guest partners before processing
      const invalidPartners = formData.guest_partners
        .map((partner, index) => {
          const errors = [];
          if (!partner.name) errors.push("name");
          if (!partner.mobile_number) errors.push("mobile number");
          if (!partner.gender) errors.push("gender");
          if (!partner.relationship) errors.push("relationship");
          if (!partner.id_proof_type) errors.push("ID proof type");
          if (!partner.files?.id_proof_front && !partner.id_proof_front)
            errors.push("ID proof front");
          if (!partner.files?.id_proof_back && !partner.id_proof_back)
            errors.push("ID proof back");
          if (!partner.files?.partner_photo && !partner.partner_photo)
            errors.push("partner photo");

          return errors.length > 0
            ? { index: index + 1, missing: errors }
            : null;
        })
        .filter(Boolean);

      if (invalidPartners.length > 0) {
        const errorMessage = invalidPartners
          .map((p) => `Partner ${p.index} is missing: ${p.missing.join(", ")}`)
          .join("\n");

        Swal.fire({
          icon: "error",
          title: "Incomplete Partner Information",
          text: errorMessage,
        });
        setIsSubmitting(false);
        return;
      }

      // Format guest partners data as an array
      formData.guest_partners.forEach((partner, index) => {
        // Append partner's basic information as a string array
        formDataToSend.append(
          `guest_partners[${index}][name]`,
          partner.name.trim()
        );
        formDataToSend.append(
          `guest_partners[${index}][mobile_number]`,
          partner.mobile_number.trim()
        );
        formDataToSend.append(
          `guest_partners[${index}][gender]`,
          partner.gender
        );
        formDataToSend.append(
          `guest_partners[${index}][relationship]`,
          partner.relationship.trim()
        );
        formDataToSend.append(
          `guest_partners[${index}][id_proof_type]`,
          partner.id_proof_type
        );

        // Handle partner files
        if (partner.files?.id_proof_front instanceof File) {
          formDataToSend.append(
            `guest_partners[${index}][id_proof_front]`,
            partner.files.id_proof_front
          );
          console.log(
            `Added id_proof_front for partner ${index}:`,
            partner.files.id_proof_front.name
          );
        }
        if (partner.files?.id_proof_back instanceof File) {
          formDataToSend.append(
            `guest_partners[${index}][id_proof_back]`,
            partner.files.id_proof_back
          );
          console.log(
            `Added id_proof_back for partner ${index}:`,
            partner.files.id_proof_back.name
          );
        }
        if (partner.files?.partner_photo instanceof File) {
          formDataToSend.append(
            `guest_partners[${index}][partner_photo]`,
            partner.files.partner_photo
          );
          console.log(
            `Added partner_photo for partner ${index}:`,
            partner.files.partner_photo.name
          );
        }
      });

      // Debug log to check all form data entries
      console.log("FormData entries:");
      for (let [key, value] of formDataToSend.entries()) {
        console.log(
          `${key}:`,
          value instanceof File ? `File: ${value.name}` : value
        );
      }

      const response = await addReservationAPI(formDataToSend);

      if (response.success) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Reservation created successfully",
        });

        resetFormWithFiles();
        setModal(false);
        await fetchReservations();
      }
    } catch (error) {
      console.error("Error creating reservation:", error);
      let errorMessage = "Failed to create reservation";

      if (error.response?.data?.error) {
        if (typeof error.response.data.error === "string") {
          errorMessage = error.response.data.error;
        } else if (error.response.data.error.errors) {
          // Handle Sequelize validation errors
          errorMessage = error.response.data.error.errors
            .map((err) => err.message)
            .join("\n");
        }
      }

      Swal.fire({
        icon: "error",
        title: "Error",
        text:
          error.response?.status === 413
            ? "The photos are too large for the server. Retake them or choose smaller photos."
            : error.response?.data?.message ||
              (error.message === "Network Error"
                ? "Could not reach the server. Check your internet connection and try again."
                : `${errorMessage}${error.response?.status ? ` (${error.response.status})` : ""}`),
      });
    } finally {
      setIsSubmitting(false);
    }
  };

const handleEdit = async (reservation_id) => {
  try {
    const id = Number(reservation_id);
    const response = await getReservationById(id);

    if (!response?.success || !response?.data) {
      Swal.fire({ icon: "error", title: "Error", text: "No reservation data" });
      return;
    }

    // ✅ Support BOTH response shapes
    const d = response.data;

  const reservation_details = rd(d);



    const guest_details =
      d.guest_details || d.guestDetails || d.guest || {};

    const room_details =
      d.room_details || d.roomDetails || d.room || {};

    // ✅ prevent undefined crash
    const status = reservation_details?.status ?? "PENDING";

    // Check restriction safely
    const now = new Date();
    if (status === "CHECKED_OUT") {
      const checkoutDateStr = reservation_details?.check_out_date;
      if (checkoutDateStr) {
        const checkoutDate = new Date(checkoutDateStr);
        const hoursSinceCheckout = (now - checkoutDate) / (1000 * 60 * 60);

        if (hoursSinceCheckout > 24) {
          Swal.fire({
            icon: "warning",
            title: "Edit Not Allowed",
            text: "Reservations cannot be modified after 24 hours of checkout",
          });
          return;
        }
      }
    }

    // ✅ map safely (no .guest_id crash)
    const mappedData = {
      guest_id: guest_details?.guest_id ?? "",
      mobile_number: guest_details?.mobile_number ?? "",
      guest_name: guest_details?.guest_name ?? guest_details?.first_name
        ? `${guest_details?.first_name ?? ""} ${guest_details?.last_name ?? ""}`.trim()
        : "",

      room_id: room_details?.room_id ?? "",
      room_number: room_details?.room_number ?? "",
      room_type: room_details?.room_type ?? "",

      check_in_date: reservation_details?.check_in_date ?? "",
      check_out_date: reservation_details?.check_out_date ?? "",
      number_of_nights: reservation_details?.number_of_nights ?? "",
      status,

      tariff_charges: reservation_details?.tariff_charges ?? "",
      food_charges: reservation_details?.food_charges ?? "",
      discount: reservation_details?.discount ?? "",
      payment_mode: reservation_details?.payment_mode ?? "",
      remark: reservation_details?.remark ?? "",
      package: (reservation_details?.package ?? "").toString().trim(),
      extrabedcharges: reservation_details?.extrabedcharges ?? 0,

      guest_type: reservation_details?.guest_type ?? "",
      id_proof_type: reservation_details?.id_proof_type ?? "",
      no_of_beds: reservation_details?.no_of_beds ?? "",
      ac_non_ac: reservation_details?.ac_non_ac ?? "",
      booking_source: reservation_details?.booking_source ?? "",
      Amount_Advance: reservation_details?.Amount_Advance ?? 0,

      guest_partners: (guest_details?.partners ?? []).map((p) => ({
        name: p?.name ?? "",
        mobile_number: p?.mobile_number ?? "",
        gender: p?.gender ?? "",
        relationship: p?.relationship ?? "",
        id_proof_type: p?.id_proof_type ?? "",
        id_proof_front: p?.id_proof_front ?? "",
        id_proof_back: p?.id_proof_back ?? "",
        partner_photo: p?.partner_photo ?? "",
        files: { id_proof_front: null, id_proof_back: null, partner_photo: null },
      })),
    };

    setFormData(mappedData);
    setCurrentReservationId(id);
    setEditModal(true);
  } catch (error) {
    console.error("Error fetching reservation:", error);
    Swal.fire({
      icon: "error",
      title: "Error",
      text: error.response?.data?.message || "Failed to fetch reservation details",
    });
  }
};

  const handleUpdate = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const user = JSON.parse(localStorage.getItem("user"));
      const hotel_id =
        user?.role === "HOTEL_ADMIN" ? user?.hotel_id : user?.hotel?.hotel_id;

      if (!hotel_id) {
        console.error("Hotel ID not found");
        setIsSubmitting(false);
        return;
      }

      const formDataToSend = new FormData();

      // Append all regular form fields except files and guest partners
      Object.keys(formData).forEach((key) => {
        if (
          ![
            "id_proof_front",
            "id_proof_back",
            "guest_photo",
            "guest_partners",
          ].includes(key)
        ) {
          formDataToSend.append(key, formData[key]);
        }
      });

      // Append main guest files
      Object.entries(fileInputs).forEach(([key, file]) => {
        if (file) {
          formDataToSend.append(key, file);
        }
      });

      formDataToSend.append("hotel_id", hotel_id);

      // Append guest partners data with proper field names
      formData.guest_partners.forEach((partner, index) => {
        // Append partner's basic information
        formDataToSend.append(
          `guest_partners[${index}][name]`,
          partner.name || ""
        );
        formDataToSend.append(
          `guest_partners[${index}][mobile_number]`,
          partner.mobile_number || ""
        );
        formDataToSend.append(
          `guest_partners[${index}][gender]`,
          partner.gender || ""
        );
        formDataToSend.append(
          `guest_partners[${index}][relationship]`,
          partner.relationship || ""
        );
        formDataToSend.append(
          `guest_partners[${index}][id_proof_type]`,
          partner.id_proof_type || ""
        );

        // Append partner's files with proper field names
        if (partner.files) {
          if (partner.files.id_proof_front) {
            formDataToSend.append(
              `guest_partners[${index}][id_proof_front]`,
              partner.files.id_proof_front
            );
          }
          if (partner.files.id_proof_back) {
            formDataToSend.append(
              `guest_partners[${index}][id_proof_back]`,
              partner.files.id_proof_back
            );
          }
          if (partner.files.partner_photo) {
            formDataToSend.append(
              `guest_partners[${index}][partner_photo]`,
              partner.files.partner_photo
            );
          }
        }
      });

      // Debug log to check the FormData contents
      for (let pair of formDataToSend.entries()) {
        console.log(pair[0], pair[1]);
      }

      const response = await updateReservation(
        currentReservationId,
        formDataToSend
      );

      if (response.success) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Reservation updated successfully",
        });
        setEditModal(false);
        fetchReservations();
        resetFormWithFiles();
      }
    } catch (error) {
      console.error("Error updating reservation:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response?.data?.message || "Failed to update reservation",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleRoomSelect = (room) => {
    if (!room || !room.room_id) {
      console.error("Invalid room selection");
      return;
    }

    // Ensure room_id is a number
    const roomId = parseInt(room.room_id);
    if (isNaN(roomId)) {
      console.error("Invalid room_id:", room.room_id);
      return;
    }

    setFormData((prev) => ({
      ...prev,
      room_id: roomId,
      room_number: room.room_number || "",
      room_type: room.room_type || "",
      tariff_charges: room.tariff || 0,
      ac_non_ac: room.ac_no_ac?.toLowerCase() || "",
    }));
  };

  const handleViewDetails = (reservationId, index) => {
    navigate(`/reservation/${reservationId}?index=${index}`);
  };

  // const handleOpenCheckoutModal = async (reservationId) => {
  //   console.log("Opening checkout modal for reservation ID:", reservationId); // Log the reservation ID
  //   try {
  //     const response = await fetchReservationDetails(reservationId);
  //     console.log("Fetched Reservation Details:", response); // Debug log

  //     if (response.success) {
  //       setCheckoutDetails({
  //         room_number: response.data.room_details.room_number,
  //         guest_id: response.data.guest_details.guest_id,
  //         guest_name: response.data.guest_details.guest_name,
  //         check_in_date: response.data.reservation_details.check_in_date,
  //         check_out_date: response.data.reservation_details.check_out_date,
  //         room_details: response.data.room_details,
  //         food_charges: response.data.reservation_details.food_charges || 0,
  //         spa_appointments: response.data.spa_appointments || [],
  //         discount: response.data.reservation_details.discount || 0,
  //         Amount_Advance: response.data.reservation_details.Amount_Advance || 0,
  //         room_charges: response.data.room_details.tariff || 0,
  //         spa_charges: calculateSpaCharges(
  //           response.data.spa_appointments || []
  //         ),
  //         extra_bed_charges:
  //           response.data.reservation_details.extra_bed_charges || 0,
  //         total_amount: 0,
  //         final_amount: 0,
  //         payment_mode: response.data.reservation_details.payment_mode || "",
  //         payment_status: "PENDING",
  //         notes: response.data.reservation_details.remark || "",
  //         reservationId: reservationId, // Add reservationId to checkoutDetails
  //       });
  //       setCheckoutModal(true); // Open the modal
  //     }
  //   } catch (error) {
  //     console.error("Error opening checkout modal:", error);
  //     Swal.fire({
  //       icon: "error",
  //       title: "Error",
  //       text: "Failed to fetch checkout details",
  //     });
  //   }
  // };

//  const handleOpenCheckoutModal = async (reservationId) => {
//   console.log("Opening checkout modal for reservation ID:", reservationId);

//   try {
//     const response = await fetchReservationDetails(reservationId);
//     console.log("Fetched Reservation Details:", response);

//     if (!response?.success) return;

//     const d = response.data;

//     // ✅ room and guest objects exist in your response
//     const room = d.room || {};
//     const guest = d.guest || {};

//     setCheckoutDetails({
//       reservationId,

//       // Guest info
//       guest_id: guest.guest_id ?? d.guest_id ?? null,
//       guest_name:
//         d.guest_name ??
//         `${guest.first_name ?? ""} ${guest.last_name ?? ""}`.trim(),

//       // Room info
//       room_number: room.room_number ?? d.room_number ?? "",
//       room_details: room,

//       // Dates
//       check_in_date: d.check_in_date ?? "",
//       check_out_date: d.check_out_date ?? "",

//       // Charges (use your response keys)
//       food_charges: Number(d.total_food_charges ?? d.food_charges ?? 0),
//       discount: Number(d.discount ?? 0),
//       Amount_Advance: Number(d.Amount_Advance ?? 0),

//       // ✅ tariff is tariff_charges in your response
//       room_charges: Number(d.tariff_charges ?? 0),

//       // ✅ extra bed is extrabedcharges in your response
//       extra_bed_charges: Number(d.extrabedcharges ?? 0),

//       // Spa (not coming in your payload -> default)
//       spa_appointments: d.spa_appointments || [],
//       spa_charges: calculateSpaCharges(d.spa_appointments || []),

//       // Totals (will be recalculated in modal anyway)
//       total_amount: 0,
//       final_amount: 0,

//       payment_mode: d.payment_mode ?? "",
//       payment_status: d.payment_status ?? "PENDING",
//       notes: d.remark ?? "",
//       pending_amount: Number(d.pending_amount ?? 0),
//     });

//     setCheckoutModal(true);
//   } catch (error) {
//     console.error("Error opening checkout modal:", error);
//     Swal.fire({
//       icon: "error",
//       title: "Error",
//       text: "Failed to fetch checkout details",
//     });
//   }
// };

//06/02/2026
// const handleOpenCheckoutModal = async (reservationId) => {
//   console.log("Opening checkout modal for reservation ID:", reservationId);

//   try {
//     const response = await fetchReservationDetails(reservationId);
//     console.log("Fetched Reservation Details:", response);

//     if (!response?.success) return;

//     const d = response.data;

//     // ✅ Get customer_id from response
//     const customer_id = d.customer_id || null;

//     setCheckoutDetails({
//       reservationId,
//       customer_id, // ✅ CRITICAL: Include customer_id

//       // Guest info
//       guest_id: d.guest?.guest_id ?? d.guest_id ?? null,
//       guest_name:
//         d.guest_name ??
//         `${d.guest?.first_name ?? ""} ${d.guest?.last_name ?? ""}`.trim(),

//       // Room info
//       room_number: d.room?.room_number ?? d.room_number ?? "",
//       room_details: d.room || {},

//       // Dates
//       check_in_date: d.check_in_date ?? "",
//       check_out_date: d.check_out_date ?? "",

//       // Charges - food will be fetched fresh
//       food_charges: 0, // ✅ Will be updated by fetchActualFoodCharges
//       discount: Number(d.discount ?? 0),
//       Amount_Advance: Number(d.Amount_Advance ?? 0),

//       room_charges: Number(d.tariff_charges ?? 0),
//       extra_bed_charges: Number(d.extrabedcharges ?? 0),

//       // Spa
//       spa_appointments: d.spa_appointments || [],
//       spa_charges: calculateSpaCharges(d.spa_appointments || []),

//       // Totals
//       total_amount: 0,
//       final_amount: 0,

//       payment_mode: d.payment_mode ?? "",
//       payment_status: d.payment_status ?? "PENDING",
//       notes: d.remark ?? "",
//       pending_amount: Number(d.pending_amount ?? 0),
//     });

//     setCheckoutModal(true);
//   } catch (error) {
//     console.error("Error opening checkout modal:", error);
//     Swal.fire({
//       icon: "error",
//       title: "Error",
//       text: "Failed to fetch checkout details",
//     });
//   }
// };

const getNights = (data) => {
  const directNights = Number(data?.number_of_nights);

  if (Number.isFinite(directNights) && directNights > 0) {
    return directNights;
  }

  if (data?.check_in_date && data?.check_out_date) {
    const checkIn = moment(data.check_in_date).startOf("day");
    const checkOut = moment(data.check_out_date).startOf("day");
    const diff = checkOut.diff(checkIn, "days");

    return diff > 0 ? diff : 1;
  }

  return 1;
};


const handleOpenCheckoutModal = async (reservationId) => {
  console.log("Opening checkout modal for reservation ID:", reservationId);

  try {
    const response = await fetchReservationDetails(reservationId);
    console.log("Fetched Reservation Details:", response);

    if (!response?.success) return;

    const d = response.data;

    const customer_id = d.customer_id || null;

    const numberOfNights = getNights(d);

    const roomRatePerNight = Number(
      d.room?.tariff ??
        d.room_details?.tariff ??
        d.tariff_charges ??
        0
    );

    const calculatedRoomCharges = roomRatePerNight * numberOfNights;

    const totalSpaCharges = Number(d.total_spa_charges ?? 0);

    console.log("ROOM PRICE CALCULATION:", {
      roomRatePerNight,
      numberOfNights,
      calculatedRoomCharges,
    });

    console.log("SERVICE PAYMENT META:", {
      food_payment_status: d.food_payment_status,
      food_payment_source: d.food_payment_source,
      spa_payment_status: d.spa_payment_status,
      spa_payment_source: d.spa_payment_source,
    });

    setCheckoutDetails({
      reservationId,
      customer_id,

      guest_id: d.guest?.guest_id ?? d.guest_id ?? null,
      guest_name:
        d.guest_name ??
        `${d.guest?.first_name ?? ""} ${d.guest?.last_name ?? ""}`.trim(),

      room_number: d.room?.room_number ?? d.room_number ?? "",
      room_details: d.room || {},

      check_in_date: d.check_in_date ?? "",
      check_out_date: d.check_out_date ?? "",

      number_of_nights: numberOfNights,
      room_rate_per_night: roomRatePerNight,
      room_charges: calculatedRoomCharges,

      // ✅ Food amount is fetched fresh inside CheckoutModal
      food_charges: 0,

      discount: Number(d.discount ?? 0),
      Amount_Advance: Number(d.Amount_Advance ?? 0),
      extra_bed_charges: Number(d.extrabedcharges ?? 0),

      // ✅ Restaurant status metadata
      // Backend may also return this directly. If not, CheckoutModal will fill it from checkout-food-charges API.
      food_payment_status: d.food_payment_status || "UNPAID",
      food_payment_source: d.food_payment_source || "NONE",
      food_direct_invoice_numbers: d.food_direct_invoice_numbers || [],
      direct_food_invoice_numbers: d.direct_food_invoice_numbers || [],

      // ✅ SPA amount + status metadata
      spa_appointments: d.spa_appointments || [],
      spa_billing_details: d.spa_billing_details || [],
      spa_charges: totalSpaCharges,
      total_spa_charges: totalSpaCharges,

      spa_payment_status: d.spa_payment_status || "UNPAID",
      spa_payment_source: d.spa_payment_source || "NONE",
      spa_direct_invoice_numbers: d.spa_direct_invoice_numbers || [],

      total_amount: 0,
      final_amount: 0,

      payment_mode: d.payment_mode ?? "",
      payment_status: d.payment_status ?? "PENDING",
      notes: d.remark ?? "",
      pending_amount: Number(d.pending_amount ?? 0),
    });

    setCheckoutModal(true);
  } catch (error) {
    console.error("Error opening checkout modal:", error);
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "Failed to fetch checkout details",
    });
  }
};


  // Callback function to update state immediately after checkout
  const handleCheckoutSuccess = (reservationId) => {
    // Immediately update the local state to reflect the checkout
    setReservations((prevReservations) =>
      prevReservations.map((reservation) => {
        if (reservation.reservation_details.reservation_id === reservationId) {
          return {
            ...reservation,
            reservation_details: {
              ...reservation.reservation_details,
              status: "CHECKED_OUT",
            },
          };
        }
        return reservation;
      })
    );

    // Refresh the data to ensure consistency
    fetchReservations();
  };

  const handleFinalCheckout = async () => {
    try {
      const response = await checkoutReservation(
        currentReservationId,
        checkoutDetails
      );
      if (response.success) {
        // Immediately update the local state to reflect the checkout
        setReservations((prevReservations) =>
          prevReservations.map((reservation) => {
            if (
              reservation.reservation_details.reservation_id ===
              currentReservationId
            ) {
              return {
                ...reservation,
                reservation_details: {
                  ...reservation.reservation_details,
                  status: "CHECKED_OUT",
                },
              };
            }
            return reservation;
          })
        );

        setCheckoutModal(false);
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Checkout completed successfully",
        });

        // Refresh the data to ensure consistency
        fetchReservations();
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to complete checkout",
      });
    } finally {
      fetchReservations();
    }
  };

  const handleCheckin = async (reservationId) => {
    try {
      // Find the reservation details to populate the modal
      const reservation = reservations.find(
        (res) => res.reservation_details.reservation_id === reservationId
      );

      if (reservation) {
        setCheckinDetails({
          reservation_id: reservationId,
          guest_name: reservation.guest_details.guest_name,
          room_number: reservation.room_details.room_number,
          check_in_date: reservation.reservation_details.check_in_date,
          check_in_time: getCurrentTime12Hour(), // Default to current time in 12-hour format
        });
        setCheckinModal(true);
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to open check-in modal",
      });
    }
  };

  const handleFinalCheckin = async () => {
    try {
      // First update the check-in time (save in 12-hour format with AM/PM)
      const timeResponse = await updatecheckintimeAPI({
        reservation_id: checkinDetails.reservation_id,
        check_in_time: checkinDetails.check_in_time, // Send 12-hour format directly
      });

      if (timeResponse.success) {
        // Then proceed with the actual check-in
        const checkinResponse = await checkinReservation(
          checkinDetails.reservation_id
        );

        if (checkinResponse.success) {
          // Immediately update the local state to reflect the check-in
          setReservations((prevReservations) =>
            prevReservations.map((reservation) => {
              if (
                reservation.reservation_details.reservation_id ===
                checkinDetails.reservation_id
              ) {
                return {
                  ...reservation,
                  reservation_details: {
                    ...reservation.reservation_details,
                    status: "CHECKED_IN",
                  },
                };
              }
              return reservation;
            })
          );

          Swal.fire({
            icon: "success",
            title: "Success",
            text: "Guest checked in successfully",
            html: `
              <p><strong>Guest:</strong> ${checkinDetails.guest_name}</p>
              <p><strong>Room:</strong> ${checkinDetails.room_number}</p>
              <p><strong>Check-in Time:</strong> ${checkinDetails.check_in_time}</p>
              <p><small class="text-success">Time saved: ${checkinDetails.check_in_time}</small></p>
            `,
          });
          setCheckinModal(false);

          // Refresh the data to ensure consistency
          fetchReservations();
        }
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response?.data?.message || "Failed to check in reservation",
      });
    }
  };

  const calculateSpaCharges = (spaAppointments) => {
    if (!Array.isArray(spaAppointments) || spaAppointments.length === 0) {
      return 0;
    }
    return spaAppointments.reduce((total, appointment) => {
      const price = Number(
        (appointment &&
          appointment.SpaService &&
          appointment.SpaService.price) ??
          appointment?.price ??
          0
      );
      return total + (isNaN(price) ? 0 : price);
    }, 0);
  };

  const renderForm = (handleSubmitFunc) => (
    <Form onSubmit={handleSubmitFunc} encType="multipart/form-data">
      <Row>
        <Col md={12}>
          <FormGroup>
            <Label>Search Guest by Mobile</Label>
            <Input
              type="text"
              value={formData.mobile_number || ""}
              onChange={(e) => {
                const value = e.target.value;
                setFormData((prev) => ({ ...prev, mobile_number: value }));
                if (value.length >= 10) {
                  searchGuestByMobile(value);
                }
              }}
              placeholder="Enter mobile number"
              pattern="[0-9]{10}"
              title="Please enter a valid 10-digit mobile number"
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <FormGroup>
            <Label>Guest Name</Label>
            <Input
              type="text"
              name="guest_name"
              value={formData.guest_name}
              onChange={handleInputChange}
              readOnly
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <FormGroup>
            <Label>Check In Date</Label>
            <Input
              type="date"
              name="check_in_date"
              value={formData.check_in_date}
              onChange={handleDateChange}
              min={
                editModal
                  ? formData.check_in_date
                  : new Date().toISOString().split("T")[0]
              }
              required
            />
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup>
            <Label>Check Out Date</Label>
            <Input
              type="date"
              name="check_out_date"
              value={formData.check_out_date}
              onChange={handleDateChange}
              min={
                formData.check_in_date || new Date().toISOString().split("T")[0]
              }
              required
            />
          </FormGroup>
        </Col>
        {dateError && (
          <Col md={12}>
            <div className="text-danger">{dateError}</div>
          </Col>
        )}
      </Row>
      <Row>
        <Row>
          <Col md={6}>
            <RoomDropdown
              onRoomSelect={handleRoomSelect}
              initialRoomId={formData.room_id}
              className="mb-3"
            />
          </Col>
          <Col md={6}>
            <FormGroup>
              <Label>Number of Nights</Label>
              <Input
                type="number"
                name="number_of_nights"
                value={formData.number_of_nights}
                onChange={handleInputChange}
              />
            </FormGroup>
          </Col>
        </Row>
      </Row>
      <Row>
        <Col md={6}>
          <FormGroup>
            <Label>Room Type</Label>
            <Input
              type="select"
              name="room_type"
              value={formData.room_type}
              onChange={handleInputChange}
            >
              <option value="">Select Room Type</option>
              <option value="SINGLE">Single</option>
              <option value="DOUBLE">Double</option>
              <option value="SUITE">Suite</option>
            </Input>
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup>
            <Label>Number of Beds</Label>
            <Input
              type="number"
              name="no_of_beds"
              value={formData.no_of_beds}
              onChange={handleInputChange}
            />
          </FormGroup>
        </Col>
      </Row>

      <Row>
        <Col md={6}>
          <FormGroup>
            <Label>Payment Mode</Label>
            <Input
              type="select"
              name="payment_mode"
              value={formData.payment_mode}
              onChange={handleInputChange}
            >
              <option value="">Select Payment Mode</option>
              <option value="cash">Cash</option>
              <option value="card">Card</option>
              <option value="upi">UPI</option>
            </Input>
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup>
            <Label>AC/Non-AC</Label>
            <Input
              type="select"
              name="ac_non_ac"
              value={formData.ac_non_ac}
              onChange={handleInputChange}
            >
              <option value="">Select Type</option>
              <option value="ac">AC</option>
              <option value="non-ac">Non-AC</option>
            </Input>
          </FormGroup>
        </Col>
      </Row>

      <Row>
     
        <Col md={6}>
          <FormGroup>
            <Label>Extra Bed Charges</Label>
            <Input
              type="number"
              name="extrabedcharges"
              value={formData.extrabedcharges || 0}
              onChange={handleInputChange}
            />
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup>
            <Label>Food Charges</Label>
            <Input
              type="number"
              name="food_charges"
              value={formData.food_charges}
              onChange={handleInputChange}
            />
          </FormGroup>
        </Col>
       <Col md={6}>
  <FormGroup>
    <Label>Advance Amount</Label>
    <Input
      type="number"
      name="Amount_Advance"
      value={formData.Amount_Advance || ""}
      onChange={(e) => {
        const advAmt = Number(e.target.value);
        const tariff = Number(formData.tariff_charges) || 0;

        // ✅ Validation: advance > tariff असेल तर block करा
        if (tariff > 0 && advAmt > tariff) {
          Swal.fire({
            icon: "warning",
            title: "Invalid Advance Amount",
            text: `Advance amount (₹${advAmt}) cannot be greater than room tariff (₹${tariff})`,
          });
          // tariff पर्यंत cap करा
          setFormData((prev) => ({ ...prev, Amount_Advance: tariff }));
          return;
        }
        handleInputChange(e);
      }}
      placeholder="Enter advance amount"
      max={formData.tariff_charges || undefined}
    />
    {/* ✅ Helper text - tariff select असेल तरच दाखवा */}
    {Number(formData.tariff_charges) > 0 && (
      <small className="text-muted">
        Max allowed: ₹{Number(formData.tariff_charges).toFixed(2)} (Room Tariff)
      </small>
    )}
    {/* ✅ Warning - advance > tariff */}
    {Number(formData.Amount_Advance) > Number(formData.tariff_charges) &&
      Number(formData.tariff_charges) > 0 && (
        <small className="text-danger d-block">
          ⚠️ Advance cannot exceed room tariff of ₹{formData.tariff_charges}
        </small>
    )}
  </FormGroup>
</Col>
      </Row>

      <Row>
        <Col md={6}>
          <FormGroup>
            <Label>Tariff Charges</Label>
            <Input
              type="number"
              name="tariff_charges"
              value={formData.tariff_charges}
              onChange={handleInputChange}
            />
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup>
            <Label>Package/Plan</Label>
            <Input
              type="select"
              name="package"
              value={formData.package || ""}
              onChange={(e) => {
                console.log("[Form] Package changed:", e.target.value);
                handleInputChange(e);
              }}
            >
              <option value="">Select Package</option>
              <option value="CONTINENTAL PLAN">Continental Plan</option>
              <option value="EUROPEAN PLAN">European Plan</option>
            </Input>
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup>
            <Label>Guest Type</Label>
            <Input
              type="select"
              name="guest_type"
              value={formData.guest_type}
              onChange={handleInputChange}
            >
              <option value="">Select Guest Type</option>
              <option value="regular">Regular</option>
              <option value="vip">VIP</option>
              <option value="corporate">Corporate</option>
            </Input>
          </FormGroup>
        </Col>
      </Row>

      <Row>
        <Col md={12}>
          <FormGroup>
            <Label>Remark</Label>
            <Input
              type="textarea"
              name="remark"
              value={formData.remark}
              onChange={handleInputChange}
            />
          </FormGroup>
        </Col>
      </Row>

      <Row>
        <Col md={6}>
          <FormGroup>
            <Label>ID Proof Type</Label>
            <Input
              type="select"
              name="id_proof_type"
              value={formData.id_proof_type}
              onChange={handleInputChange}
            >
              <option value="">Select ID Proof</option>
              <option value="aadhar">Aadhar Card</option>
              <option value="passport">Passport</option>
              <option value="driving">Driving License</option>
            </Input>
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup>
            <Label>Status</Label>
            <Input
              type="select"
              name="status"
              value={formData.status}
              onChange={handleInputChange}
            >
              <option value="PENDING">PENDING</option>
              <option value="CONFIRMED">CONFIRMED</option>
              <option value="CANCELLED">CANCELLED</option>
            </Input>
          </FormGroup>
        </Col>
      </Row>

      {/* Main guest file uploads */}
      <Row>
        <Col md={4}>
          <FormGroup>
            <Label>ID Proof Front</Label>
            <Input
              type="file"
              name="id_proof_front"
              accept="image/*"
              onChange={handleFileChange}
              className="form-control"
            />
            {fileInputs.id_proof_front && (
              <small className="text-success">
                File selected: {fileInputs.id_proof_front.name}
              </small>
            )}
            {fileSizeErrors.id_proof_front && (
              <small className="text-danger d-block">
                {fileSizeErrors.id_proof_front}
              </small>
            )}
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <Label>ID Proof Back</Label>
            <Input
              type="file"
              name="id_proof_back"
              accept="image/*"
              onChange={handleFileChange}
              className="form-control"
            />
            {fileInputs.id_proof_back && (
              <small className="text-success">
                File selected: {fileInputs.id_proof_back.name}
              </small>
            )}
            {fileSizeErrors.id_proof_back && (
              <small className="text-danger d-block">
                {fileSizeErrors.id_proof_back}
              </small>
            )}
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <Label>Guest Photo</Label>
            <Input
              type="file"
              name="guest_photo"
              accept="image/*"
              onChange={handleFileChange}
              className="form-control"
            />
            {fileInputs.guest_photo && (
              <small className="text-success">
                File selected: {fileInputs.guest_photo.name}
              </small>
            )}
            {fileSizeErrors.guest_photo && (
              <small className="text-danger d-block">
                {fileSizeErrors.guest_photo}
              </small>
            )}
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <FormGroup>
          <Label>booking Source</Label>
          <Input
            type="text"
            name="booking_source"
            value={formData.booking_source}
            onChange={handleInputChange}
          />
        </FormGroup>
      </Row>

      {/* Guest Partners Section */}
      <div className="mt-4 mb-3">
        <div className="d-flex justify-content-start align-items-start flex-column">
          <h4>Guest Partners</h4>
        </div>

        {formData.guest_partners.map((partner, index) => (
          <GuestPartnerForm
            key={index}
            partner={partner}
            index={index}
            onInputChange={handlePartnerInputChange}
            onFileChange={handlePartnerFileChange}
            onRemove={removeGuestPartner}
            fileSizeErrors={partnerFileSizeErrors}
          />
        ))}

        <Button
          color="success"
          size="sm"
          onClick={addGuestPartner}
          type="button"
        >
          Add Partner
        </Button>
      </div>

      <div className="text-end mt-3">
        <Button type="submit" color="primary" disabled={isSubmitting}>
          {isSubmitting ? (
            <>
              <span
                className="spinner-border spinner-border-sm me-1"
                role="status"
                aria-hidden="true"
              ></span>
              {editModal ? "Updating..." : "Creating..."}
            </>
          ) : editModal ? (
            "Update Reservation"
          ) : (
            "Create Reservation"
          )}
        </Button>
      </div>
    </Form>
  );

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title="Reservations"
            breadcrumbItem="Manage Reservations"
          />

          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <div className="d-flex justify-content-between align-items-center flex-column flex-md-row mb-4 gap-2">
                    <div className="w-100 w-md-auto">
                      <AmountStatusFilter
                        amountStatus={amountStatusFilter}
                        onAmountStatusChange={handleAmountStatusChange}
                      />
                    </div>
                    <div className="d-flex flex-column flex-md-row gap-2">
                      <ReservationExcelExport />
                      <Button
                        color="primary"
                        onClick={() => setModal(true)}
                        className="w-100 w-md-auto"
                      >
                        New Reservation
                      </Button>
                    </div>
                  </div>

                  <div className="table-responsive">
                    <Table className="table-centered table-nowrap">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Guest Name</th>
                          <th className="d-none d-md-table-cell">Room No.</th>
                          {/* <th className="d-none d-lg-table-cell">Room Type</th> */}
                          <th className="d-none d-md-table-cell">Check In</th>
                          <th className="d-none d-lg-table-cell">Check Out</th>
                          <th className="d-none d-lg-table-cell">Nights</th>
                          <th className="d-none d-lg-table-cell">Tariff</th>
                          {/* <th className="d-none d-lg-table-cell">Package</th> */}
                          <th className="d-none d-lg-table-cell">
                            Extra Bed Charges
                          </th>
                          <th className="d-none d-md-table-cell">Status</th>
                          <th className="d-none d-md-table-cell">Partners</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredReservations?.map((reservation, i) => {
  const reservation_details = rd(reservation);
  const guest_details = gd(reservation);
  const room_details = roomd(reservation);

  const status = reservation_details?.status ?? "—";

  return (
    <tr key={reservation_details?.reservation_id ?? i}>
      <td>{i + 1}</td>

      <td>
        <div className="d-flex flex-column">
          <span>{guest_details?.guest_name ?? "—"}</span>

          <small className="text-muted d-md-none">
            Room: {room_details?.room_number ?? "—"}
          </small>

          <small className="text-muted d-md-none">
            Status: {status}
          </small>
        </div>
      </td>

      <td className="d-none d-md-table-cell">
        {room_details?.room_number ?? "—"}
      </td>

      <td className="d-none d-md-table-cell">
        {reservation_details?.check_in_date
          ? moment(reservation_details.check_in_date).format("DD-MM-YYYY")
          : "—"}
      </td>

      <td className="d-none d-lg-table-cell">
        {reservation_details?.check_out_date
          ? moment(reservation_details.check_out_date).format("DD-MM-YYYY")
          : "—"}
      </td>

      <td className="d-none d-lg-table-cell">
        {reservation_details?.number_of_nights ?? "—"}
      </td>

      <td className="d-none d-lg-table-cell">
        ₹{reservation_details?.tariff_charges ?? 0}
      </td>

      <td className="d-none d-lg-table-cell">
        {reservation_details?.extrabedcharges
          ? `₹${reservation_details.extrabedcharges}`
          : "N/A"}
      </td>

      <td className="d-none d-md-table-cell">
        <ReservationStatusBadge status={status} />
      </td>

      <td className="d-none d-md-table-cell">
        <Badge color="info">{guest_details?.partners?.length ?? 0}</Badge>
      </td>

      <td>
        <div className="d-flex gap-1 flex-wrap justify-content-center">
          <Button
            color="info"
            size="sm"
            onClick={() => handleEdit(reservation_details?.reservation_id)}
            disabled={!reservation_details?.reservation_id}
          >
            <i className="mdi mdi-pencil"></i>
          </Button>

          <Button
            color="primary"
            size="sm"
            onClick={() =>
              handleViewDetails(reservation_details?.reservation_id, i + 1)
            }
            disabled={!reservation_details?.reservation_id}
          >
            <i className="mdi mdi-eye"></i>
          </Button>

          {(status === "CONFIRMED" || status === "PENDING") && (
            <Button
              color="success"
              size="sm"
              onClick={() => handleCheckin(reservation_details?.reservation_id)}
              disabled={!reservation_details?.reservation_id}
            >
              <span className="d-none d-sm-inline">Check In</span>
              <i className="mdi mdi-login d-sm-none"></i>
            </Button>
          )}

          {status === "CHECKED_IN" && (
            <Button
              color="warning"
              size="sm"
              onClick={() => handleOpenCheckoutModal(reservation_details?.reservation_id)}
              disabled={!reservation_details?.reservation_id}
            >
              <span className="d-none d-sm-inline">Check Out</span>
              <i className="mdi mdi-logout d-sm-none"></i>
            </Button>
          )}
        </div>
      </td>
    </tr>
  );
})}

                      </tbody>
                    </Table>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <div className="d-flex justify-content-end mt-3">
            <Pagination>
              <PaginationItem
                disabled={!reservations?.pagination?.hasPreviousPage}
              >
                <PaginationLink
                  previous
                  href="#"
                  onClick={() => handlePageChange(currentPage - 1)}
                />
              </PaginationItem>
              {[
                ...Array(reservations?.pagination?.totalPages || 0).keys(),
              ]?.map((pageNumber) => (
                <PaginationItem
                  active={currentPage === pageNumber + 1}
                  key={pageNumber}
                >
                  <PaginationLink
                    href="#"
                    onClick={() => handlePageChange(pageNumber + 1)}
                  >
                    {pageNumber + 1}
                  </PaginationLink>
                </PaginationItem>
              ))}
              <PaginationItem disabled={!reservations?.pagination?.hasNextPage}>
                <PaginationLink
                  next
                  href="#"
                  onClick={() => handlePageChange(currentPage + 1)}
                />
              </PaginationItem>
            </Pagination>
          </div>

          {/* New Reservation Modal */}
          <Modal
            isOpen={modal}
            toggle={() => setModal(!modal)}
            size="lg"
            className="modal-fullscreen-md-down"
          >
            <ModalHeader toggle={() => setModal(!modal)}>
              <i className="fas fa-plus-circle me-2"></i>
              New Reservation
            </ModalHeader>
            <ModalBody>{renderForm(handleSubmit)}</ModalBody>
          </Modal>

          {/* Update Reservation Modal */}
          <Modal
            isOpen={editModal}
            toggle={() => setEditModal(!editModal)}
            size="lg"
          >
            <ModalHeader toggle={() => setEditModal(!editModal)}>
              <i className="fas fa-edit me-2"></i>
              Update Reservation #{currentReservationId}
            </ModalHeader>
            <ModalBody>{renderForm(handleUpdate)}</ModalBody>
          </Modal>
        </Container>

        {/* Check-in Modal */}
        <Modal
          isOpen={checkinModal}
          toggle={() => setCheckinModal(!checkinModal)}
          size="md"
        >
          <ModalHeader toggle={() => setCheckinModal(!checkinModal)}>
            <i className="fas fa-sign-in-alt me-2"></i>
            Check-in Guest
          </ModalHeader>
          <ModalBody>
            <Form>
              <Row>
                <Col md={12}>
                  <FormGroup>
                    <Label>
                      <strong>Guest Name:</strong>
                    </Label>
                    <p className="form-control-plaintext">
                      {checkinDetails.guest_name}
                    </p>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label>
                      <strong>Room Number:</strong>
                    </Label>
                    <p className="form-control-plaintext">
                      {checkinDetails.room_number}
                    </p>
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label>
                      <strong>Check-in Date:</strong>
                    </Label>
                    <p className="form-control-plaintext">
                      {checkinDetails.check_in_date
                        ? new moment(checkinDetails.check_in_date).format(
                            "DD-MM-YYYY"
                          )
                        : "N/A"}
                    </p>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={8}>
                  <FormGroup>
                    <Label for="check_in_time">Check-in Time *</Label>
                    <div className="d-flex align-items-center">
                      <Input
                        type="time"
                        id="check_in_time_24"
                        value={convertTo24Hour(checkinDetails.check_in_time)}
                        onChange={(e) => {
                          const time12Hour = convertTo12Hour(e.target.value);
                          setCheckinDetails({
                            ...checkinDetails,
                            check_in_time: time12Hour,
                          });
                        }}
                        required
                        style={{ marginRight: "10px" }}
                      />
                      <span className="fw-bold text-primary">
                        {checkinDetails.check_in_time}
                      </span>
                    </div>
                    <small className="text-muted">
                      Select time (will be displayed in 12-hour format)
                    </small>
                  </FormGroup>
                </Col>
              </Row>
              <div className="text-end mt-3">
                <Button
                  color="secondary"
                  className="me-2"
                  onClick={() => setCheckinModal(false)}
                >
                  Cancel
                </Button>
                <Button
                  color="success"
                  onClick={handleFinalCheckin}
                  disabled={!checkinDetails.check_in_time}
                >
                  <i className="fas fa-check me-1"></i>
                  Confirm Check-in
                </Button>
              </div>
            </Form>
          </ModalBody>
        </Modal>

        {/* // Add this near the end of your return statement */}
        <CheckoutModal
          isOpen={checkoutModal}
          toggle={() => setCheckoutModal(!checkoutModal)}
          checkoutDetails={checkoutDetails}
          setCheckoutDetails={setCheckoutDetails}
          handleFinalCheckout={handleFinalCheckout}
          onCheckoutSuccess={handleCheckoutSuccess}
        />
      </div>
    </React.Fragment>
  );
};

export default Reservations;
